import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";

export default function RankingList() {
  const ranking = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 6);

  const rankClass = (index: number) => {
    if (index === 0) return "bg-accent-500 text-background-50";
    if (index === 1) return "bg-secondary-500 text-foreground-950";
    if (index === 2) return "bg-secondary-300 text-foreground-900";
    return "bg-background-200 text-foreground-600";
  };

  return (
    <ol className="space-y-1">
      {ranking.map((movie, index) => (
        <li key={movie.id}>
          <Link
            to={`/detail/${movie.id}`}
            className="group flex items-center gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-100"
          >
            <span
              className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${rankClass(index)}`}
            >
              {index + 1}
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-600">
                {movie.title}
              </span>
            </span>
            <span className="shrink-0 text-xs font-semibold text-secondary-700">
              {movie.rating.toFixed(1)}
            </span>
          </Link>
        </li>
      ))}
    </ol>
  );
}